<template>
  <v-card class="bank-rules-card">
      <div class="bank-rules-header d-flex">
        <div class="title_header mr-auto primary--text">Reglas Bancarias</div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              icon
              @click="openCopyRulesDialog"
              :loading="loadingAvailableCompanies"
              class="mr-2"
              v-bind="attrs"
              v-on="on">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copiar reglas de otra empresa</span>
        </v-tooltip>
        <v-btn :disabled="!dirty"
          :class="dirty ? 'btn-active-save-rules': ''"
          color="primary"
          outlined
          icon
          @click="saveBankRules"
          :loading="loadingBankRules">
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn>
      </div>

      <!-- Dialog para copiar reglas -->
      <v-dialog v-model="copyRulesDialog" max-width="500">
        <v-card>
          <v-card-title class="headline primary--text">
            Copiar reglas de otra empresa
          </v-card-title>
          <v-card-text>
            <v-alert type="warning" dense class="mb-4">
              <strong>Atención:</strong> Esta accion es irreversible. Si ya tienes reglas configuradas en la empresa actual, seran sobreescritas por las reglas de la empresa seleccionada.
            </v-alert>
            <v-select
              v-model="selectedSourceCompany"
              :items="availableCompanies"
              item-text="name"
              item-value="id"
              label="Seleccionar empresa origen"
              outlined
              dense
              :loading="loadingAvailableCompanies"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="copyRulesDialog = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              :disabled="!selectedSourceCompany"
              :loading="loadingCopyRules"
              @click="copyRulesFromCompany">
              Copiar reglas
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar para mensajes -->
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top>
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>

      <v-toolbar        
        dense
        elevation="0">
        <v-tabs
          v-model="activeTab">
          <v-tab>Gastos</v-tab>
          <v-tab>Ingresos</v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
                        
        <v-select
          class="add-rule-select"        
          v-model="add_rule_selected"
          :items="rule_types"          
          dense
          outlined
          placeholder="Añadir regla"
          @change="addBankRule"
          hide-details
          append-icon="mdi-chevron-down"
        >
        </v-select>
        
      </v-toolbar>
    
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="tab in tabs" :key="tab.code">
          <div class="bank-rules-body">
            <div class="d-flex justify-space-between align-top">
              <v-text-field
                @input="searching"
                v-model="search_text"
                placeholder="Buscar..." 
                clearable 
                outlined 
                hide-details 
                dense 
                class="search-rule"
                @click:clear="searching(''); search_text = ''">
              </v-text-field>

              <div class="mr-2">                
                <v-checkbox
                  class="checkbox-filter-ia"
                  v-model="filter_ia"
                  hide-details
                  dense
                  @change="changeFilterIA"                            
                  >
                  <template v-slot:label>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex" 
                        v-bind="attrs"
                        v-on="on">
                          <div class="circle-with-icon mr-1">
                            <v-icon>mdi-star-four-points</v-icon>
                          </div>                    
                          Generado por IA
                        </div>
                      </template>
                      <span>Pendiente de revisión </span>
                    </v-tooltip>
                  </template>
                </v-checkbox>                 
              </div>

              <!--
              <div v-if="revisionIANeeded" class="ia-revision-needed-container d-flex align-top">
                <div class="d-flex flex-column text-right mr-2 hidden-1200-960">
                  <div>Pendiente de</div>
                  <div>Revisión</div>
                </div>
                <div class="ia-revision-needed-icon">
                  <v-icon>mdi-creation</v-icon>                  
                </div>
              </div>
              -->
            </div>
            <draggable
                @start="dragging = true"
                @end="endDraging(tab)"
                :list="getTabBankRules(tab)"
                handle=".draggable-box"
                class="draggable__scrollable"
                :disabled="(search_text != null && search_text != '') || filter_ia"
                >
                <div v-for="(rule, index) in getTabBankRules(tab)" :key="index">
                  <div v-show="rule.visible">
                    <bank-rule 
                      :rule="rule"
                      :index="index"
                      :tab="tab"
                      :company_id="company_id"
                      :num_digits="num_digits"
                      :work_with_effects="work_with_effects"
                      @removeBankRule="removeBankRule"
                      @setDirty="setDirty"
                      @aproveIACondition="aproveIACondition">
                    </bank-rule>
                    </div>
                </div>
            </draggable>
            <!-- <div class="no-draggable-box" v-show="(search_text != null && search_text != '') || filter_ia">
                <template v-for="(rule, index) in getTabBankRules(tab)">
                  <bank-rule v-if="rule.visible"
                    :key="rule.order" 
                    :rule="rule"
                    :index="index"
                    :tab="tab"
                    :company_id="company_id"
                    :num_digits="num_digits"
                    :work_with_effects="work_with_effects"
                    @removeBankRule="removeBankRule"
                    @setDirty="setDirty"
                    @aproveIACondition="aproveIACondition">
                  </bank-rule>                      
                </template>
            </div> -->

          </div>
        </v-tab-item>
      </v-tabs-items> 
            
  </v-card>
</template>



<script>
import draggable from "vuedraggable";
import { BankRulesQuery } from "@/modules/bank/application/BankRulesQuery";
import DocTextField from "./DocTextField.vue"
import { UpdateCompanyBankRulesCommand } from "@/modules/bank/application/UpdateCompanyBankRulesCommand";
import { CopyCompanyBankRulesCommand } from "@/modules/bank/application/CopyCompanyBankRulesCommand";
import { GetAvailableCompaniesQuery } from "@/modules/bank/application/GetAvailableCompanies";
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import BankRule from "@/components/BankRule.vue"

export default {
  name: 'BankRules',
  components: {      
      draggable,
      DocTextField,
      BankRule,
  },
  props: {
      company_id: {
          type: [String, Number],
          required: true
      },
      num_digits: {
        type: Number,
        required: true
      },
      work_with_effects: {
        type: Boolean,
        default: false
      }
  },
  data () {
      return {
          activeTab:null,
          tabs: [
            {code: "debit", "name": "Gastos"},
            {code: "credit", "name": "Ingresos"}
          ],
          loadingBankRules: false,
          debit_bank_rules: [],
          credit_bank_rules: [],
          dragging: false,
          dirty: false,
          search_text:"",
          add_rule_selected: 0,
          filter_ia: false,
          copyRulesDialog: false,
          selectedSourceCompany: null,
          availableCompanies: [],
          loadingAvailableCompanies: false,
          loadingCopyRules: false,
          snackbar: false,
          snackbarMessage: '',
          snackbarColor: 'success'
      }
  },
  async mounted() {
    const that = this
    this.$root.$on('getCompanyBankRules', function(){that.getCompanyBankRules()})
    await this.getCompanyBankRules();
  },
  methods: {    
      sanetizeRules(rules) {        
        let aux_rules = JSON.parse(JSON.stringify(rules)); //Clonamos
        aux_rules.forEach(el => delete el.order);
        aux_rules.forEach(el => delete el.show_concept);
        return aux_rules;        
      },
      async saveBankRules() {
          this.loadingBankRules = true;
          try {
            //debugger;            
            await new UpdateCompanyBankRulesCommand(sync_command_dispatcher, this).run(this.company_id, this.sanetizeRules(this.debit_bank_rules), this.sanetizeRules(this.credit_bank_rules))
          } catch(error) {
              console.error('Error UpdateCompanyBankRules:', error);
          }
          this.unsetDirty();
          this.loadingBankRules = false;
      },
      async getCompanyBankRules() {
          this.loadingBankRules = true;
          try {                
              await new BankRulesQuery(query_dispatcher, this).run(this.company_id);                
          } catch (error) {
              console.error('Error getting bank rules list', error)                
          }
           this.loadingBankRules = false;
      },
      removeBankRule({tab, index}) {        
        this.setDirty();
        if (tab.code == 'debit') {
          this.debit_bank_rules.splice(index,1);
          this.debit_bank_rules.forEach(function(value, i){
            value.order = i;
          });          
        }
        else {
          this.credit_bank_rules.splice(index,1);
          this.credit_bank_rules.forEach(function(value, i){
            value.order = i;
          }); 
        }
        // if (!this.revisionIANeeded) {
        //   this.filter_ia = false;
        // }
      },
      addBankRule() {
        if (this.add_rule_selected != null) {          
          this.setDirty();
          this.search_text = "";
          this.filter_ia = false;
          if (this.activeTab == 0) {          
            this.debit_bank_rules.unshift({ 'order': 0, 'visible': true, 'kind': this.add_rule_selected, 'text': '', 'show_concept': (this.add_rule_selected == "counterpart_by_vat"), 'concept': '', 'counterpart': [{ 'amount': 100, 'account': '' }] });          
          } else {          
            this.credit_bank_rules.unshift({ 'order': 0, 'visible': true, 'kind': this.add_rule_selected, 'text': '', 'show_concept': (this.add_rule_selected == "counterpart_by_vat"), 'concept': '', 'counterpart': [{ 'amount': 100, 'account': '' }] });          
          }
          this.debit_bank_rules.forEach(function(value, i){
            value.order = i;
          });
          this.credit_bank_rules.forEach(function(value, i){
            value.order = i;
          });
        }
        this.$nextTick(() => {
          this.add_rule_selected = 0;
        });        
      },
      aproveIACondition() {
        if (!this.revisionIANeeded) {
          this.filter_ia = false;
        }
      },           
      getTabBankRules(tab) {
        if (tab.code == "debit") {
          return this.debit_bank_rules;
        }
        else {
          return this.credit_bank_rules;
        }
      },
      endDraging(tab) {
        this.setDirty();
        this.getTabBankRules(tab).forEach(function(value, i){
          value.order = i;
        });
        this.dragging = false;
      },
      focusRuleCounterpart(code, index) {   
        let selector = 'br_counterpart_' + code + '_' + index;
        this.$refs[selector][0].$refs['combobox_account_am'].focus();
        this.$refs[selector][0].$refs['combobox_account_am'].activateMenu();        
      },
      setDirty(){
        this.dirty = true;
      },
      unsetDirty() {
        this.dirty = false;
      },
      searching(text) {
        if(text!=null) {
          if (this.filter_ia) {
            this.debit_bank_rules.forEach(
              item => ((item.text.toLowerCase().includes(text.toLowerCase()) ||
              item.concept.toLowerCase().includes(text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(text.toLowerCase())))) &&  item.revision_needed)? item.visible=true : item.visible=false
            );
            this.credit_bank_rules.forEach(
              item => ((item.text.toLowerCase().includes(text.toLowerCase()) ||
              item.concept.toLowerCase().includes(text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(text.toLowerCase()))))  &&  item.revision_needed)? item.visible=true : item.visible=false
            );
          } else {
            this.debit_bank_rules.forEach(
              item => (item.text.toLowerCase().includes(text.toLowerCase()) ||
              item.concept.toLowerCase().includes(text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(text.toLowerCase()))))? item.visible=true : item.visible=false
            );
            this.credit_bank_rules.forEach(
              item => (item.text.toLowerCase().includes(text.toLowerCase()) ||
              item.concept.toLowerCase().includes(text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(text.toLowerCase()))))? item.visible=true : item.visible=false
            );
          }
        }
      },
      changeFilterIA() {
        if (this.filter_ia && this.search_text != null) {
          this.debit_bank_rules.forEach(
            item => ((item.text.toLowerCase().includes(this.search_text.toLowerCase()) ||
              item.concept.toLowerCase().includes(this.search_text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(this.search_text.toLowerCase())))) && item.revision_needed)? item.visible=true : item.visible=false
          );
          this.credit_bank_rules.forEach(
            item => ((item.text.toLowerCase().includes(this.search_text.toLowerCase()) ||
              item.concept.toLowerCase().includes(this.search_text.toLowerCase()) || 
              (item.counterpart.some(e => e.account.toLowerCase().includes(this.search_text.toLowerCase())))) && item.revision_needed)? item.visible=true : item.visible=false
          );
        } else {
          if (this.search_text == null)
            this.search_text = "";
          this.searching(this.search_text)
        }
      },
      async openCopyRulesDialog() {
        this.loadingAvailableCompanies = true;
        try {
          await new GetAvailableCompaniesQuery(query_dispatcher, this).run(this.company_id);
        } catch (error) {
          console.error('Error getting available companies:', error);
        }
        this.loadingAvailableCompanies = false;
        this.selectedSourceCompany = null;
        this.copyRulesDialog = true;
      },
      async copyRulesFromCompany() {
        if (!this.selectedSourceCompany) return;
        this.loadingCopyRules = true;
        try {
          const result = await new CopyCompanyBankRulesCommand(sync_command_dispatcher, this).run(
            this.selectedSourceCompany,
            this.company_id
          );
          if (result && result.error) {
            this.snackbarMessage = result.message || 'Error al copiar las reglas';
            this.snackbarColor = 'error';
            this.snackbar = true;
          } else {
            this.copyRulesDialog = false;
            await this.getCompanyBankRules();
            this.snackbarMessage = 'Reglas copiadas correctamente';
            this.snackbarColor = 'success';
            this.snackbar = true;
          }
        } catch (error) {
          console.error('Error copying rules:', error);
          this.snackbarMessage = 'Error al copiar las reglas';
          this.snackbarColor = 'error';
          this.snackbar = true;
        }
        this.loadingCopyRules = false;
      }
  },
  computed: {
    rule_types() {
      const baseTypes = [
        { value: "account_counterparts", text: "Contrapartidas cuenta" },
        { value: "cif_account_counterpart", text: "Contrapartida cuenta por CIF" },
        { value: "invoice_number_account_counterpart", text: "Contrapartida por Num. Factura"},
        { value: "amount_account_counterpart", text: "Contrapartida por Importe"}
      ];

      // Solo añadir la regla de terceros si se trabaja con efectos
      if (this.work_with_effects) {
        baseTypes.push({ value: "third_party_concept_account_counterpart", text: "Contrapartida por Nombre de Tercero" });
      }

      return baseTypes;
    },

    // filtered_debit_bank_rules: function() {
    //   let aux = this.debit_bank_rules      
    //   if (this.search_text != "" && this.search_text != null) {
    //     aux = aux.filter(item => (item.text.toLowerCase().includes(this.search_text.toLowerCase()) || item.concept.toLowerCase().includes(this.search_text.toLowerCase()) || (item.counterpart.some(e => e.account.toLowerCase().includes(this.search_text.toLowerCase())))))
    //   }
    //   if (this.filter_ia) {
    //     aux = aux.filter(item => (item.revision_needed))
    //   }
    //   return aux;      
    // },
    // filtered_credit_bank_rules: function() {
    //   let aux = this.credit_bank_rules;
    //   if (this.search_text != "" && this.search_text != null) {
    //     aux = aux.filter(item => (item.text.toLowerCase().includes(this.search_text.toLowerCase()) || item.concept.toLowerCase().includes(this.search_text.toLowerCase()) || (item.counterpart.some(e => e.account.toLowerCase().includes(this.search_text.toLowerCase())))))
    //     //return this.credit_bank_rules.filter(searchTextInRule, this.search_text)
    //   }
    //   if (this.filter_ia) {
    //     aux = aux.filter(item => (item.revision_needed));
    //   }
    //   return aux;
    // },
    // revisionIANeeded: function() {
    //   for (let i in this.debit_bank_rules) {
    //     if (this.debit_bank_rules[i].hasOwnProperty("revision_needed") && this.debit_bank_rules[i]['revision_needed']) {
    //       return true;
    //     }
    //   }
    //   for (let i in this.credit_bank_rules) {
    //     if (this.credit_bank_rules[i].hasOwnProperty("revision_needed") && this.credit_bank_rules[i]['revision_needed']) {
    //       return true;
    //     }
    //   } 
    //   return false;     
    // }
  },
}
</script>

<style scoped>

.ia-revision-needed-container {
  font-size:10px;
  color:var(--v-primary-base);
  min-width: 100px;
}
.ia-revision-needed-container .ia-revision-needed-icon{
  width: 27px;
  height: 27px;
  background-color: var(--v-primary-base);
  border-radius: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ia-revision-needed-container .ia-revision-needed-icon .v-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);  
}
.checkbox-filter-ia {
  margin-top:0px;
  padding-top:2px;
}
.checkbox-filter-ia >>> .v-input--selection-controls__input {
  margin-right: 1px;
}
.checkbox-filter-ia >>> .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before {    
    -webkit-transform: scale(1.0) !important;
    transform: scale(1.0) !important;
    -webkit-transition: none;
    transition: none;
}
.checkbox-filter-ia >>> .v-label{
  font-size:11px;
  color:var(--v-primary-base);
}
.checkbox-filter-ia >>> .v-label .circle-with-icon{
    width: 17px;
    height: 17px;
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    border-radius: 15px;
    text-align: center;  
    display: flex;    
    align-items: center;    
    justify-content: center;    
}
.checkbox-filter-ia >>> .v-label .v-icon {
  font-size:11px;
  width: 16px;
  height: 16px;
  color:var(--v-primary-base);
}
.checkbox-filter-ia .v-input .v-input--selection-controls {
  margin-top:0px;
}
.bank-rules-card {  
  border-radius: 10px;  
  background-color: white;
  box-shadow:none;
  min-height: calc(100vh - 75px);
}
.bank-rules-card .add-rule-select {
  font-size:11px;
  font-weight: 300;
  color: var(--v-primary-base);
  max-width: 100px;
}
.bank-rules-card .add-rule-select >>> fieldset {
  border-color: var(--v-primary-base);
}
.bank-rules-card .add-rule-select >>> .v-input__slot {
  padding: 0px 0px 0px 6px !important;
  min-height: 20px !important;
}
.bank-rules-card .add-rule-select >>> .v-input__icon {
  height: 14px;
}
.bank-rules-card .add-rule-select >>> .v-icon {
  font-size: 14px;
  color:var(--v-primary-base);
}
.bank-rules-card .add-rule-select >>> .v-select__selections {
  padding: 0px !important;
}
.bank-rules-card .add-rule-select >>> input{
  padding:0px !important;
}
.bank-rules-card .add-rule-select >>> .v-input__append-inner {
  margin-top: 3px !important;
}
.bank-rules-card .add-rule-select >>> ::placeholder {
  color: var(--v-primary-base);
  opacity: 1; /* Firefox */
}

.bank-rules-card .add-rule-select >>> ::-ms-input-placeholder { /* Edge 12 -18 */
  color: var(--v-primary-base);
}

.bank-rules-card .bank-rules-header {
  padding:20px 10px;
}
.bank-rules-card .title_header {
  font-size:20px;
}

.bank-rules-card .btn-active-save-rules {
  background-color: var(--v-primary-base);  
}
.bank-rules-card .btn-active-save-rules .v-icon {
  color: white !important;
}
.bank-rules-card .v-toolbar {
  background-color: #F8F8F8;
}
.bank-rules-card .v-tab {
  text-transform: none;
  font-weight: 300;
}
.bank-rules-card .v-toolbar .add-rule-text {
  font-size: 9px;
  font-weight: 300;
  width: 60px;
  text-align: right;
  margin-right:8px;
}
.bank-rules-card .v-toolbar .btn-add-rule {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
  margin-right: -5px !important;
}
.bank-rules-card .v-toolbar .btn-add-rule:hover {
  background-color: #bebcfd;
}
.bank-rules-card .v-toolbar .v-btn .v-icon {
  font-size: 16px;  
  width: 16px;
  height: 16px;
}
.bank-rules-card .bank-rules-body {
  padding:15px 10px;
}
.row-bank-rule {  
  border-radius: 10px;
  margin-bottom:10px;
}
.search-rule {
  font-size:12px;
  font-weight: 300;
  max-width: 200px;
  margin-left:10px;
}
.search-rule >>> .v-input__slot {
  min-height: 25px !important;
  margin-bottom:10px;
  padding-right: 2px !important;
  padding-left: 8px !important;
}
.search-rule >>> .v-input__slot fieldset {
  border-radius:20px;
}
.search-rule >>> .v-input__slot input {
  padding-top:4px !important;
  padding-bottom:4px !important;
}
.search-rule >>> .v-input__slot .v-input__append-inner {
  margin-top:2px !important;
}
.search-rule >>> .v-input__slot .v-icon {
  font-size:14px;
  width: 14px;
  height: 14px;
}

@media (min-width:960px) and (max-width:1200px) {
  .bank-rules-card .hidden-1230-960 {
    display: none !important;  
  }
  .bank-rules-card .ia-revision-needed-container {
    min-width: 30px !important;
  }
}

.draggable__scrollable {
  padding:10px 0px !important;
  overflow-y: auto !important;
  max-height: 538px !important;
  scrollbar-width: thin;
}
</style>